export default __webpack_public_path__ + "static/media/book-nav-icon3.8bea0e67.svg";